import './Footer.css';

function Footer() {
  return (
      <footer> 
        <p>Jenna Chestnut | <a href='https://linktr.ee/jenna.chestnut' target='_blank' rel='noreferrer'>@Jennabot</a>
        </p>
        <span>Created using MongoDB, ExpressJS, React, and Node</span>
      </footer>
  );
}

export default Footer;